import { render } from "./FreezeRecord.vue?vue&type=template&id=0f525ebe&scoped=true&ts=true"
import script from "./FreezeRecord.vue?vue&type=script&lang=ts"
export * from "./FreezeRecord.vue?vue&type=script&lang=ts"

import "./FreezeRecord.vue?vue&type=style&index=0&id=0f525ebe&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f525ebe"]])

export default __exports__